export function tenantSlug(input: string): string {
  let s = String(input || "").trim();

  s = s.replace(/\u0130/g, "I").replace(/\u0131/g, "i");

  s = s.toLowerCase();
  s = s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");

  return s
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}
